/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    // Label,
    // FormGroup,
    Row,
    // Label,
    Input,
    // Button,
    // Table,
    // Form,
    // Badge,
    // Input,
    CardHeader,
    CardFooter,
    Col,
    Container,
} from "reactstrap";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import { Link, useHistory } from "react-router-dom";
import CurrencyInput from 'react-currency-input-field';
// import SweetAlert from "react-bootstrap-sweetalert";

// import { MapContainer, TileLayer, Marker } from 'react-leaflet';
// import "leaflet/dist/leaflet.css";
// import L from "leaflet";
// import markerIconPng from "leaflet/dist/images/marker-icon.png";

// Fix default marker agar muncul
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//     iconUrl: require("leaflet/dist/images/marker-icon.png"),
//     iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//     shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

export default function DetailDokumenCanvaser(props) {
    // const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    // const username = localStorage.username;
    const [description, setDescription] = useState("");
    const [long, setLong] = useState(0);
    const [lat, setLat] = useState(0);
    const [alamat, setAlamat] = useState("");
    const [email, setEmail] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [namaproyek, setNamaProyek] = useState("");
    const [namacustomer, setNamaCustomer] = useState("");
    const [savedItems, setSavedItems] = useState([]);
    // const [uomConversions, setUomConversions] = useState({});
    // const [totalPrice, setTotalPrice] = useState(0);
    // const [isSearchShoww, setIsSearchShoww] = useState(false);
    // const [allItemm, setAllItemm] = useState([]);
    // const [queryy, setQueryy] = useState("");
    // const headers = { Authorization: `Bearer ${token}` };
    const [totaldiskon, setTotalDiskon] = useState(0);
    // const [grandtotal, setGrandTotal] = useState(0);
    const [image1, setImage1] = useState("");
    const [image2, setImage2] = useState("");
    const [image3, setImage3] = useState("");
    const [image4, setImage4] = useState("");
    const [image5, setImage5] = useState("");
    let history = useHistory();

    const [diskonglobalnominal, setDiskonGlobalNominal] = useState(0);
    const [diskonglobalpersen, setDiskonGlobalPersen] = useState(0);
    const [ongkir1, setOngkir1] = useState(0);
    const [ppnnew, setPPNNEW] = useState(0);
    const [totalPrice1, setTotalPrice1] = useState(0);
    // const a = useState(0);
    const [diskonglobalnominal1, setDiskonGlobalNominal1] = useState(0)
    const [totaldiskon2, setTotalDiskon2] = useState(0);
    const [qtyTotal, setTotalQty] = useState(0);
    const [diskontotal, setDiskonTotal] = useState(0);
    const [tanggal, setTanggal] = React.useState(null);
    const [kodecanvasing, setKodeCanvasing] = useState("");
    const [approve, setApprove] = useState(0);
    const [coderfq, setCodeRFQ] = useState("");

    useEffect(() => {
        getById();
        getItemDataSaved();
        getByCodeRFQ();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/canvasing/get?code=${props.match.params.code}`, { headers })
            .then((data) => {
                const res = data.data.response;
                const lat = parseFloat(res.latitude_proyek);
                const lng = parseFloat(res.longitude_proyek);
                setImage1(res.foto1);
                setImage2(res.foto2);
                setImage3(res.foto3);
                setImage4(res.foto4);
                setImage5(res.foto5);
                setApprove(res.approve);
                setKodeCanvasing(res.canvasing_code);
                setDescription(res.keterangan_canvasing);
                setAlamat(res.manual_alamat_proyek);
                setTanggal(res.created_at);
                // setCustomer(res.customer_id);
                setNamaCustomer(res.customer_name);
                setNamaProyek(res.nama_proyek);
                setWhatsapp(res.customer_phone);
                setEmail(res.customer_email);
                setLat(lat);
                setLong(lng);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getByCodeRFQ = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/rfq-so/get-by-canvasing/${props.match.params.code}`, { headers })
            .then((data) => {
                const res = data.data.response;
                setCodeRFQ(res.rfq_code);
                // const res = data.data.response;
                // const lat = parseFloat(res.latitude_proyek);
                // const lng = parseFloat(res.longitude_proyek);
                // setImage1(res.foto1);
                // setImage2(res.foto2);
                // setImage3(res.foto3);
                // setImage4(res.foto4);
                // setImage5(res.foto5);
                // setApprove(res.approve);
                // setKodeCanvasing(res.canvasing_code);
                // setDescription(res.keterangan_canvasing);
                // setAlamat(res.manual_alamat_proyek);
                // // setCustomer(res.customer_id);
                // setNamaCustomer(res.customer_name);
                // setNamaProyek(res.nama_proyek);
                // setWhatsapp(res.customer_phone);
                // setEmail(res.customer_email);
                // setLat(lat);
                // setLong(lng);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        setDiskonGlobalNominal1(diskonglobalnominal);
    }, [diskonglobalnominal]);

    // diskon bayangan
    useEffect(() => {
        setTotalDiskon(diskonglobalnominal1);
    }, [diskonglobalnominal1]);

    //diskon tampil
    useEffect(() => {
        setTotalDiskon2((totaldiskon));
    }, [totaldiskon]);

    //ongkir tampil
    useEffect(() => {
        setOngkir1(0);
    }, []);

    useEffect(() => {
        setTotalPrice1((qtyTotal));
    }, [qtyTotal]);


    // diskonglobalnominal dan persen
    useEffect(() => {
        diskonglobalnominal === "diskonglobalnominal" && setDiskonGlobalPersen((diskonglobalnominal / qtyTotal) * 100);
        diskonglobalpersen === "diskonglobalpersen" && setDiskonGlobalNominal((qtyTotal) * (diskonglobalpersen / 100));
    }, [diskonglobalnominal, qtyTotal, diskonglobalpersen, diskontotal, diskonglobalpersen]);

    // hasil nominal dari PPN
    useEffect(() => {
        setPPNNEW((qtyTotal - totaldiskon) - ((qtyTotal - totaldiskon)));
    }, [qtyTotal, totaldiskon]);

    // hasil grandtotal
    // useEffect(() => {
    //     setGrandTotal((totalPrice1 - totaldiskon2) + ppnnew - a);
    // }, [totalPrice1, qtyTotal, totaldiskon2, ppnnew, a]);

    const recalculateTotals = (items = savedItems) => {
        let total = 0;
        let diskonTotal = 0;

        items.forEach(item => {
            const harga = parseFloat(item.harga) || 0;
            const diskonNominal = parseFloat(item.diskon_nominal) || 0;
            const qty = parseFloat(item.qty) || 0;

            total += (harga - diskonNominal) * qty;
            diskonTotal += diskonNominal * qty;
        });

        setTotalQty(total);         // Total Harga - Diskon
        setDiskonTotal(diskonTotal); // Total Diskon Nominal
    };

    useEffect(() => {
        recalculateTotals();
    }, [savedItems]);

    const getItemDataSaved = () => {
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/rfq-so/item-by-canvasing`, {

            canvasing_code: props.match.params.code

        }).then(async response => {
            let stateItem = [];

            await Promise.all(response.data.response.map(async (data) => {
                stateItem = [...stateItem, {
                    image_url: data.image_url || "",
                    item_id: data.item_id,
                    item_name: data.item_name,
                    item_code: data.item_code,
                    is_konsinyasi: data.is_konsinyasi,
                    uom_id: data.uom_id,
                    uom_conversion_id: data.uom_conversion_id,
                    satuan: data.satuan,
                    qty: data.qty,
                    harga: data.harga,
                    diskon_nominal: data.diskon_nominal,
                    diskon_persen: data.diskon_persen,
                    data: {
                        item_name: data.item_name,
                        harga: data.harga
                    },
                }];
            }));
            setSavedItems(stateItem);
        })
    }

    const formatRupiah = (money) => {
        return new Intl.NumberFormat('id-ID',
            { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
        ).format(money);
    }

    return (
        <>
            <div>
                <SimpleHeaderMobile to="/mobile/sales/page" />
                <Container className="mt--6" fluid>
                    {lat && long ? (
                        <>

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-primary text-white">
                                    <h5 className="mb-0 text-white">📄 Detail Proyek</h5>
                                </CardHeader>
                                <CardBody>
                                    {[
                                        { label: "Kode", value: kodecanvasing },
                                        { label: "Penawaran", value: coderfq },
                                        { label: "Tanggal", value: tanggal },
                                        { label: "Proyek", value: namaproyek },
                                        { label: "Customer", value: namacustomer },
                                        { label: "Alamat", value: alamat },
                                        { label: "Proyek", value: namaproyek },
                                        { label: "Customer", value: namacustomer },
                                        { label: "Alamat", value: alamat },
                                        {
                                            label: "WhatsApp", value: whatsapp ? (
                                                <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer">{whatsapp}</a>
                                            ) : "-"
                                        },
                                        {
                                            label: "Email", value: email ? (
                                                <a href={`mailto:${email}`}>{email}</a>
                                            ) : "-"
                                        },
                                        { label: "Deskripsi", value: description },
                                        { label: "Validasi", value: approve === 5 ? "Disetujui" : approve === 4 ? "Ditolak" : "Menunggu Persetujuan" },
                                    ].map((item, idx) => (
                                        <Row key={idx} className="mb-2">
                                            <Col xs="4" className="font-weight-bold text-sm">{item.label}</Col>
                                            <Col xs="8" className="text-sm">{item.value || "-"}</Col>
                                        </Row>
                                    ))}
                                </CardBody>
                            </Card>

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-info text-white">
                                    <h5 className="mb-0 text-white">🛒 Item Penawaran</h5>
                                </CardHeader>

                                <CardBody>
                                    {savedItems.length === 0 ? (
                                        <p className="text-center text-muted">Belum ada item ditambahkan</p>
                                    ) : (
                                        savedItems.map((item, index) => {
                                            const subtotal = parseFloat(item.harga || 0) * parseFloat(item.qty || 0);
                                            return (
                                                <div key={index} className="border-bottom pb-2 mb-3">
                                                    <Row>
                                                        <Col xs="3">
                                                            <img
                                                                src={item.image_url === "" || item.image_url === " " || item.image_url === "" ? require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default : item.image_url}
                                                                alt="x"
                                                                className="img-fluid rounded"
                                                            />
                                                        </Col>
                                                        <Col xs="9">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div>
                                                                    <strong>{item.item_name}</strong>
                                                                    <br />
                                                                    <small className="text-muted">{item.item_code}</small>
                                                                </div>
                                                            </div>

                                                            <Row className="mt-2">
                                                                <Col xs="6">
                                                                    <CurrencyInput
                                                                        disabled
                                                                        className="form-control form-control-sm"
                                                                        prefix="Rp "
                                                                        value={item.harga}
                                                                        // onValueChange={(value) => handleEditHarga(index, value)}
                                                                        placeholder="Harga"
                                                                    />
                                                                </Col>
                                                                <Col xs="6">
                                                                    <CurrencyInput
                                                                        disabled
                                                                        className="form-control form-control-sm"
                                                                        value={item.qty}
                                                                        // onValueChange={(value) => handleEditQty(index, value)}
                                                                        placeholder="Qty"
                                                                    />

                                                                </Col>
                                                                <Col hidden>
                                                                    {item.is_konsinyasi}
                                                                    {item.uom_conversion_id}
                                                                    {item.uom_id}
                                                                </Col>
                                                            </Row>

                                                            <Row className="mt-2">
                                                                <Col xs="6">
                                                                    <Input
                                                                        className="form-control form-control-sm"
                                                                        value={item.satuan}
                                                                        disabled
                                                                    />
                                                                </Col>
                                                                <Col xs="6">
                                                                    <Input
                                                                        className="form-control form-control-sm bg-light"
                                                                        disabled
                                                                        value={formatRupiah(subtotal)}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            );
                                        })
                                    )}
                                </CardBody>

                                {savedItems.length > 0 && (
                                    <CardFooter>
                                        <Row>
                                            <Col xs="6">
                                                <div><strong>Total</strong></div>
                                                <div><strong>Diskon</strong></div>
                                                <div><strong>PPN</strong></div>
                                                <div><strong>Ongkir</strong></div>
                                                <div className="mt-2 text-success"><strong>Grand Total</strong></div>
                                            </Col>
                                            <Col xs="6" className="text-right">
                                                <div>{formatRupiah(totalPrice1)}</div>
                                                <div>{formatRupiah(totaldiskon2)}</div>
                                                <div>{formatRupiah(ppnnew)}</div>
                                                <div>{formatRupiah(ongkir1)}</div>
                                                <div className="mt-2 text-success"><strong>{formatRupiah(totalPrice1)}</strong></div>
                                            </Col>
                                        </Row>
                                    </CardFooter>
                                )}
                            </Card>

                            <Card className="shadow mb-4">
                                <CardHeader className="bg-info text-white">
                                    <h5 className="mb-0 text-white">🛒 Gambar Dokumentasi</h5>
                                </CardHeader>
                            </Card>

                            <Row className="mt-3">
                                {[1, 2, 3, 4, 5].map((num, index) => (
                                    <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                        <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                            {/* <input
                                                hidden
                                                id={`formId${num}`}
                                                name="file"
                                                type="file"
                                                accept="image/*"
                                                onChange={(event) => {
                                                    const file = event.target.files[0];
                                                    if (file) {
                                                        switch (num) {
                                                            case 1: setImage1(file); break;
                                                            case 2: setImage2(file); break;
                                                            case 3: setImage3(file); break;
                                                            case 4: setImage4(file); break;
                                                            case 5: setImage5(file); break;
                                                            default: break;
                                                        }
                                                    }
                                                }}
                                            /> */}
                                            {num === 1 && (
                                                <>
                                                    {image1 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image1}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 2 && (
                                                <>
                                                    {image2 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image2}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 3 && (
                                                <>
                                                    {image3 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image3}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 4 && (
                                                <>
                                                    {image4 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image4}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 5 && (
                                                <>
                                                    {image5 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image5}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </label>
                                    </Col>
                                ))}
                            </Row>


                            {/* {cartItems.length > 0 && (
                                <Card className="shadow mb-5">
                                    <CardHeader className="bg-info text-white">
                                        <h5 className="mb-0 text-white">🛒 Daftar Item</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {cartItems.map((item, idx) => (
                                            <Row key={idx} className="mb-2 align-items-center">
                                                <Col xs="8">{item.name}</Col>
                                                <Col xs="4" className="text-right">
                                                    <Button size="sm" color="danger" onClick={() => removeItem(idx)}>
                                                        Hapus
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ))}
                                    </CardBody>
                                </Card>
                            )} */}

                            {/* <Row className="mt-3">
                                {[1, 2, 3, 4, 5].map((num, index) => (
                                    <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                        <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                            <input
                                                hidden
                                                id={`formId${num}`}
                                                name="file"
                                                type="file"
                                                accept="image/*"
                                                onChange={(event) => {
                                                    const file = event.target.files[0];
                                                    if (file) {
                                                        switch (num) {
                                                            case 1: setImage1(file); break;
                                                            case 2: setImage2(file); break;
                                                            case 3: setImage3(file); break;
                                                            case 4: setImage4(file); break;
                                                            case 5: setImage5(file); break;
                                                            default: break;
                                                        }
                                                    }
                                                }}
                                            />
                                            {num === 1 && (
                                                <>
                                                    {image1 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image1}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 2 && (
                                                <>
                                                    {image2 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image2}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 3 && (
                                                <>
                                                    {image3 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image3}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 4 && (
                                                <>
                                                    {image4 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image4}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {num === 5 && (
                                                <>
                                                    {image5 === "" ? (
                                                        <img
                                                            alt="..."
                                                            src={require("assets/img/theme/NO-IMAGE-AVAILABLE-2.png").default}
                                                            width="100%"
                                                        />
                                                    ) : (
                                                        <img
                                                            alt=""
                                                            src={image5}
                                                            width="100%"
                                                        />
                                                    )}
                                                </>
                                            )}
                                        </label>
                                    </Col>
                                ))}
                            </Row> */}

                        </>
                    ) : (
                        <p className="text-center">Loading lokasi proyek...</p>
                    )}
                </Container>
            </div>
        </>
    );
}
